var module = angular.module('octopusApp.infrastructure');

module.filter('filterUsers', function() {
  return function (collection, search) {
    if (!search || search === "" || !collection) {
      return collection;
    }

    return collection.filter(function (item) {

      var searchText = latinize(search).toLowerCase();
      return latinize((item.Username || "").toLowerCase()).indexOf(searchText) !== -1 ||
              latinize((item.DisplayName || "").toLowerCase()).indexOf(searchText) !== -1;
    });
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/filters/filterUsers.js
// module id = 688
// module chunks = 1